import { LocalStorage } from "./storage"


export const write = (key, data) => {
  LocalStorage.set(key, data);
}

export const getFromCache = (key) => {
  return LocalStorage.get(key);
}